"use strict";

export function initInScope($scope) {

    if (!_config.currentSelectedCountry){
        try{
            // remove this code as there is now the suggestion modal for country selection
            // if(!window.sessionStorage.getItem('countryModal')) {
            //     $('#modalCountrySelect').modal('show');
            // }

            $('#modalCountrySelect').on('hidden.bs.modal', function (e) {
                window.sessionStorage.setItem('countryModal', true);
                //select country AT as fallback if user dismisses modal
                if(!window.sessionStorage.getItem('countrySelect')) {
                    window.sessionStorage.setItem('countrySelect', 'AT');
                }
            });
        }catch(e){
            console.log(e);
        }
    }

    $('.js-close-country-select').on('click', function (e) {
        let selectedCounty = $(this).data('country').toUpperCase();
        $('#modalCountrySelect').modal('hide');
        window.sessionStorage.setItem('countryModal', true);
        window.sessionStorage.setItem('countrySelect', selectedCounty);
        window.localStorage.setItem('currentCountry', selectedCounty);
    });

}